import React from "react";
import { InfoContaienr } from "../../styled/setting";
import { TfiSearch } from "react-icons/tfi";
import Search from "./search";

const Info = ({
  message = "",
  searched = "",
  setSearched = null,
  searchEvent = null,
  actions = null,
  placeholder = "상품명을 입력해주세요.",
}) => {
  const formatMessage = (message) => {
    if (!message) return null;

    const parts = message.split(/(\*\*.*?\*\*)/g).map((part, index) => {
      if (part.match(/^\*\*(.*?)\*\*$/)) {
        return <strong key={index}> {part.replace(/\*\*/g, "")}</strong>;
      }
      return <>{part}</>;
    });

    return <span>{parts}</span>;
  };

  const renderActions = () => {
    if (!actions) return null;
    return (
      <div className="actions">
        {actions.map((item, index) => (
          <button key={index} onClick={item.func} className={item.key}>
            {item.Icon ? <item.Icon /> : item.label}
          </button>
        ))}
      </div>
    );
  };

  return (
    <InfoContaienr>
      <div className="heading">
        {formatMessage(message)}
        {setSearched && renderActions()}
      </div>
      {!setSearched && renderActions()}
      {setSearched && (
        <Search
          placeholder={placeholder}
          searchEvent={searchEvent}
          setSearched={setSearched}
          searched={searched}
        />
      )}
    </InfoContaienr>
  );
};

export default Info;
